import { getSessionState } from "src/pageDefinitions/session";

declare module "src/pageDefinitions/session" {
  interface BrowserSessionState {
    glp1Answer?: "yes" | "prescription" | "noButConsidering" | "no";
    glp1FollowUpAnswer?: "yes" | "no";
    planInterestAnswer?: "yes" | "no" | "notSure";
  }
}

export function hasAnsweredToGLP1InCurrentSession(
  expectedAnswer: "yes" | "prescription" | "noButConsidering" | "no"
) {
  const { glp1Answer } = getSessionState("browser");
  return glp1Answer === expectedAnswer;
}

export function hasAnsweredToGLP1FollowUpInCurrentSession(
  expectedAnswer: "yes" | "no"
) {
  const { glp1FollowUpAnswer } = getSessionState("browser");
  return glp1FollowUpAnswer === expectedAnswer;
}

export function hasAnsweredPlanInterestInCurrentSession(
  expectedAnswer: "yes" | "no" | "notSure"
): boolean {
  const { planInterestAnswer } = getSessionState("browser");
  return planInterestAnswer === expectedAnswer;
}
